export default "__VITE_ASSET__CI2rjt9Z__"